/**
 * @file modules/popular_offers_anchor_scroll.js
 * @description Re-applies the #popular-offers-title fragment scroll after layout stabilizes.
 *              The browser's native fragment scroll fires before hero/carousel content lays
 *              out, landing at a stale offset. A double requestAnimationFrame defers the
 *              scroll until after the paint that follows subresource load. If the document
 *              is still loading, waits for window 'load' first; if already complete, only
 *              the double rAF is used.
 *
 *              NOTE: relies on hard (full-page) navigation. If reskin ever adopts
 *              soft navigation, window 'load' won't refire and this module will need a
 *              navigation / hashchange listener instead.
 */

const ANCHOR_ID = "popular-offers-title";

export function initPopularOffersAnchorScroll() {
  if (window.location.hash !== `#${ANCHOR_ID}`) return;

  function reapply() {
    const target = document.getElementById(ANCHOR_ID);
    if (!target) return;
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (document.contains(target))
          target.scrollIntoView({ behavior: "instant" });
      }),
    );
  }

  if (document.readyState === "complete") {
    reapply();
  } else {
    window.addEventListener("load", reapply, { once: true });
  }
}
